import { useCallback, useEffect, useState } from "react";
import { ethers } from "ethers";
import erc20Abi from "../constants/sourceContract/abi/abiERC20.json";
import { useWeb3React } from "@web3-react/core";
import bn from "bignumber.js";
import { ethersToBN } from "../utils";

const formatBalance = (balance) => {
    const decimals = new bn(10).pow(18);

    return ethersToBN(balance).div(decimals).toFixed();
}

const useERC20Holders = (address) => {
    const { library } = useWeb3React();
    const [balancesWithHolders, setBalancesWithHolders] = useState([]);
    const [totalMintGasUsed, setTotalMintGasUsed] = useState("0");

    const fetchHoldersBalances = useCallback(async () => {
        if(!!address) {
            const contract = new ethers.Contract(address, erc20Abi, !!library ? library.getSigner() : library);

            const filter = contract.filters.Transfer();
            const events = await contract.queryFilter(filter, 0, "latest");
        
            const hashes = events.map(event => event.transactionHash);

            const txRequests = [];

            for(const hash of hashes) {
                const request = await library.getTransaction(hash).then(res => res.wait());

                txRequests.push(request);
            }

            const txs = await Promise.all(txRequests);

            let gasUsed = 0;
            for(const tx of txs) {
                gasUsed += tx.gasUsed.toNumber();
            }

            const decimals = new bn(10).pow(18);
            const gasUsedFormatted = new bn(gasUsed).div(decimals).toFixed();

            setTotalMintGasUsed(gasUsedFormatted);

            const holders = [];
            const holdersBalances = await Promise.all(
                events
                    .reduce((acc, event) => {
                        const nextHolder = event.args.to;
    
                        if(!holders.includes(nextHolder)) {
                            holders.push(nextHolder);
    
                            acc.push(contract.balanceOf(nextHolder));
                        }
    
                        return acc;
                    }, [])
            );
    
            setBalancesWithHolders(holdersBalances.map((holderBalance, holderIndex) => {
                return {
                    holder: holders[holderIndex],
                    balance: formatBalance(holderBalance),
                };
            }));
        }
    }, [address, library]);

    useEffect(() => {
        if(!!address) {
            fetchHoldersBalances();
        }
    }, [address, library, fetchHoldersBalances]);

    return { balancesWithHolders, fetchHoldersBalances, totalMintGasUsed };
};

export {
    useERC20Holders
}